<template>
  <div class="bill-info">
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.sum') }}
      </div>
      <div class="bill-info-value">{{ templateSum }} UAH</div>
    </div>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.purpose') }}
      </div>
      <div class="bill-info-value">
        {{ template.Purpose }}
      </div>
    </div>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.exp-at') }}
      </div>
      <div class="bill-info-value">
        {{ templateExpAt }}
      </div>
    </div>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.link') }}
      </div>
      <div class="bill-info-value bill-info-link">
        <div class="bill-info-link-value">
          <a :href="template.TemplateUrl" target="_blank">
            {{ template.TemplateUrl }}
          </a>
          <!--          {{ template.TemplateUrl }}-->
        </div>
        <div class="bill-info-link-copy" @click="copyBillLink">
          <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.1271 1.97028L1.125 3.5625V11.4407C1.125 12.7868 2.2163 13.8782 3.5625 13.8782L10.0247 13.8784C9.79298 14.5337 9.168 15.0032 8.4333 15.0032H3.5625C1.59499 15.0032 0 13.4082 0 11.4407V3.5625C0 2.82697 0.470587 2.20134 1.1271 1.97028ZM10.3125 0C11.2444 0 12 0.75552 12 1.6875V11.4375C12 12.3695 11.2444 13.125 10.3125 13.125H3.5625C2.63052 13.125 1.875 12.3695 1.875 11.4375V1.6875C1.875 0.75552 2.63052 0 3.5625 0H10.3125ZM10.3125 1.125H3.5625C3.25184 1.125 3 1.37684 3 1.6875V11.4375C3 11.7482 3.25184 12 3.5625 12H10.3125C10.6231 12 10.875 11.7482 10.875 11.4375V1.6875C10.875 1.37684 10.6231 1.125 10.3125 1.125Z"
              fill="#64748B"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import moment from 'moment'

export default {
  name: 'BillTemplateDetails',
  props: {
    template: {
      type: Object,
    },
  },
  computed: {
    templateSum() {
      try {
        return parseInt(this.template.Sum) / 100
      } catch (e) {
        return 0
      }
    },

    templateExpAt() {
      try {
        return moment(this.template.ExpiredAt).format('DD.MM.YYYY')
      } catch (e) {
        return '00.00.0000'
      }
    },
  },
  methods: {
    async copyBillLink() {
      try {
        await navigator.clipboard.writeText(this.template.TemplateUrl)
        //TODO: replace with correct notification
        $emit(this, 'linkCopied')
      } catch (err) {
        console.error('Failed to copy: ', err)
      }
    },
  },
  emits: ['linkCopied'],
}
</script>

<style lang="scss" scoped>
@import '@css-app/bill-details';
</style>
